module.exports = __webpack_public_path__ + "b9dc7f05a9d879b86c7ef33ee453183f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/other-apps/fitness.png
// module id = 1754
// module chunks = 1